var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpense = function SvgExpense(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_30406)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.732422 8.00006C0.732422 3.9868 3.98582 0.733398 7.99909 0.733398C12.0124 0.733398 15.2658 3.9868 15.2658 8.00006C15.2658 12.0133 12.0124 15.2667 7.99909 15.2667C3.98582 15.2667 0.732422 12.0133 0.732422 8.00006ZM7.99909 1.9334C4.64856 1.9334 1.93242 4.64954 1.93242 8.00006C1.93242 11.3506 4.64856 14.0667 7.99909 14.0667C11.3496 14.0667 14.0658 11.3506 14.0658 8.00006C14.0658 4.64954 11.3496 1.9334 7.99909 1.9334ZM4.73242 8.00006C4.73242 7.66869 5.00105 7.40006 5.33242 7.40006H10.6658C10.9971 7.40006 11.2658 7.66869 11.2658 8.00006C11.2658 8.33144 10.9971 8.60006 10.6658 8.60006H5.33242C5.00105 8.60006 4.73242 8.33144 4.73242 8.00006Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_30406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpense);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "expense.222b485d9ae9e916e1920e6eaaa37004.svg";